import React from 'react';

const Logo = ({ size = 40, className = '' }) => {
  return (
    <div
      className={`flex items-center justify-center rounded-xl ${className}`}
      style={{ width: size, height: size, background: 'linear-gradient(135deg, #0055FF 0%, #003ACC 100%)' }}
    >
      <svg
        width={size * 0.6}
        height={size * 0.6}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Rising bars (SEO growth) */}
        <rect x="4" y="20" width="4" height="8" rx="1" fill="white" opacity="0.5" />
        <rect x="10" y="14" width="4" height="14" rx="1" fill="white" opacity="0.7" />
        <rect x="16" y="8" width="4" height="20" rx="1" fill="white" opacity="0.85" />
        <rect x="22" y="4" width="4" height="24" rx="1" fill="white" />
        {/* Conductor arc (orchestra) */}
        <path
          d="M6 16C10 6 22 2 28 6"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          opacity="0.9"
        />
        {/* Baton tip sparkle */}
        <circle cx="28" cy="6" r="2" fill="#00E5FF" />
      </svg>
    </div>
  );
};

export default Logo;
